"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecentlyViewed = void 0;
const utils_1 = require("../../utils/utils");
const base_component_1 = require("../../components/base-component");
class RecentlyViewed extends base_component_1.BaseComponent {
    defaultCardsLimit;
    defaultCardImgRatio;
    defaultCardAlignment;
    containerAttribute;
    localStorageSelector;
    cardTemplateSelector;
    cardLimit;
    cardImgRatio;
    cardAlignment;
    cardSelector;
    cardAlignmentClass;
    cardInnerSelector;
    shapeClass;
    products;
    containers;
    static localStorageSelector = 'LbcTheme-RecentlyViewed';
    static defaultLimit = 50;
    constructor() {
        super();
        this.defaultCardsLimit = RecentlyViewed.defaultLimit;
        this.defaultCardImgRatio = 'portrait';
        this.defaultCardAlignment = 'left';
        this.containerAttribute = '[recently-viewed-container]';
        this.localStorageSelector = RecentlyViewed.localStorageSelector;
        this.cardTemplateSelector = 'product-card-template';
        this.cardLimit = +this.dataset.cardLimit ?? this.defaultCardsLimit;
        this.cardImgRatio = this.dataset.imgRatio ?? this.defaultCardImgRatio;
        this.cardAlignment = this.dataset.cardAlignment ?? this.defaultCardAlignment;
        this.cardSelector = 'product-card';
        this.cardAlignmentClass = `product-card--${this.cardAlignment}-alignment`;
        this.cardInnerSelector = '[data-product-card-inner]';
        this.shapeClass = `shape--${this.cardImgRatio}`;
        this.products = [];
        this.containers = (0, utils_1.$list)(this.containerAttribute, this);
    }
    async mountComponent() {
        await this.fetchItems();
        if (this.products.length > 0) {
            this.setItems();
            this.setVisible(true);
        }
    }
    fetchItems = async () => {
        const { origin } = window.location;
        const locale = window.Shopify.routes.root ?? '/';
        const currentSavedProducts = JSON.parse(localStorage.getItem(this.localStorageSelector))?.slice(0, this.cardLimit);
        if (!currentSavedProducts) {
            return;
        }
        try {
            for (const handle of currentSavedProducts) {
                const section = await fetch(`${origin}${locale}products/${handle}?sections=product-card-template`).then(res => res.json());
                const node = this.createNodeByString(section[this.cardTemplateSelector]);
                if (node) {
                    this.products.push(node);
                }
            }
        }
        catch (error) {
            console.log(error);
        }
    };
    setItems = () => {
        this.containers.forEach(container => {
            const products = this.products
                .filter(product => !!product.querySelector('product-card'))
                .map(product => product.cloneNode(true));
            container.replaceChildren(...products);
        });
    };
    setVisible(isVisible) {
        this.classList.toggle('hidden', !isVisible);
        const carousels = (0, utils_1.$list)('carousel-component', this);
        carousels.forEach(carousel => {
            const parent = carousel.parentNode;
            parent.replaceChild(carousel.cloneNode(true), carousel);
        });
    }
    createNodeByString(productString) {
        const html = new DOMParser().parseFromString(productString, 'text/html');
        const node = (0, utils_1.$el)(`.${this.cardTemplateSelector}`, html);
        (0, utils_1.$el)(this.cardSelector, node)?.classList.add(this.cardAlignmentClass);
        (0, utils_1.$el)(this.cardInnerSelector, node)?.classList.add(this.shapeClass);
        if (this.shapeClass.includes('fit')) {
            (0, utils_1.$el)(this.cardInnerSelector, node)?.classList.add('shape--fit');
        }
        return node;
    }
    static updateProductsInLocalStorage(handle) {
        if (!handle) {
            return;
        }
        const currentSavedProducts = JSON.parse(localStorage.getItem(this.localStorageSelector)) ?? [];
        const isExist = currentSavedProducts?.find((item) => item === handle);
        const newProducts = isExist
            ? currentSavedProducts
            : [handle, ...currentSavedProducts].slice(0, this.defaultLimit);
        localStorage.setItem(this.localStorageSelector, JSON.stringify(newProducts));
    }
}
exports.RecentlyViewed = RecentlyViewed;
